import {AxiosResponse} from 'axios'
import {IRequestAuth} from 'core/api'
import Client from 'core/api/client'
import {IBoosterCycle} from 'core/api/prescription/booster'
import {Eye} from 'core/api/prescription/eye'
import {ICycle} from 'core/api/prescription/treatment'
import {authHeaders} from 'core/api/utils'

export interface IPrescription {
  /** The number of days per week of usage prescribed, as an integer between 1 and 7 inclusive */
  daysPerWeekDosage: number

  /** The amount of daily dosage prescribed, in milliseconds */
  dailyDosage: number

  /** The amblyopic eye booster cycle data for the prescription to create */
  boosterCycle: IBoosterCycle

  /** The treatment cycle data for the prescription to create */
  treatmentCycle: ICycle

  /** The total duration of the prescription, in milliseconds */
  duration: number
}

export interface ICreatePatientPrescription extends IPrescription {
  /** The amblyopic eye for the prescription to create */
  amblyopicEye: Eye
}

export interface ICreatePatientPrescriptionResponse extends AxiosResponse {
  data: null
}

/**
 * Create and activate a prescription for a patient.
 * @param {IRequestAuth} auth
 * @param {string} patientId
 * @param {ICreatePatientPrescription} data
 */
export function createPatientPrescription(
  auth: IRequestAuth,
  patientId: string,
  data: ICreatePatientPrescription,
): Promise<ICreatePatientPrescriptionResponse> {
  return Client.post(
    `/patient/${patientId}/prescription`,
    data,
    {
      headers: authHeaders(auth),
      validateStatus: () => true,
      params: {activate: true},
    },
  )
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/patient/prescription.ts